import { useLazyQuery, useApolloClient } from "@apollo/client";
import { GET_STORE_DETAIL } from "../api/maps-queries";
import { STORE_INFO_FRAGMENT } from "../../../api/fragments";
import type {
  StoreDetailQuery,
  StoreDetailQueryVariables,
} from "../../../__generated__/graphql";
import type { Store } from "../../../__generated__/graphql";

export function useMapStoreDetail() {
  const apolloClient = useApolloClient();

  const [getStoreDetail, { data: storeDetailData }] = useLazyQuery<
    StoreDetailQuery,
    StoreDetailQueryVariables
  >(GET_STORE_DETAIL);

  function getStoreFromCache(storeId: number): Store | null {
    try {
      const storeData = apolloClient.cache.readFragment({
        id: `Store:${storeId}`,
        fragment: STORE_INFO_FRAGMENT,
      });
      return storeData as Store | null;
    } catch {
      return null;
    }
  }

  return {
    getStoreDetail,
    storeDetailData,
    getStoreFromCache,
  };
}
